export default {
  api_r_user_module_newsletterManager_moduleData_get: {
    path: 'm/newsletter-manager/module-data/get/',
  },
  api_r_user_module_newsletterManager_selectorOptions_get: {
    path: 'm/newsletter-manager/selector-options/get/',
  },
  api_r_user_module_newsletterManager_entry_search: {
    path: 'm/newsletter-manager/entry/search/',
  },
  api_r_user_module_newsletterManager_entry_download: {
    path: 'm/newsletter-manager/entry/download/',
  },
};
